import styled from 'styled-components';
import { colors } from '@10d/tend-ui-tokens/samolet';

export const WrapperStyled = styled.div`
  background-color: ${colors.gray25};

  padding: 16px;
  margin-bottom: 10px;

  .tend-ui-form {
    flex-direction: row;
    gap: 16px;
    flex-wrap: wrap;
  }

  .tend-ui-form > *:last-child {
    align-self: flex-end;
  }

  .tend-ui-collapse-root {
    width: 240px;
  }

  .tend-ui-collapse-content > div {
    padding: 4px 0 0 0;
  }

  .tend-ui-collapse-header {
    pointer-events: none;

    .tend-ui-button {
      display: none;
    }

    .tend-ui-icon-root {
      display: none;
    }

    .tend-ui-badge-root {
      display: none;
    }
  }
`;
